import { EmailScannerType } from '@ViewModels';
import { StyleDeclaration, css } from 'aphrodite';
import * as React from 'react';
import { useRef } from 'react';
import { baseStyleSheet } from '../../styles/styles';
import { Button } from '../Button';
import { CompoundButton, CompoundButtonType } from '../CompoundButton';
import { SuccessCheckIcon } from '../svgs/icons/SuccessCheckIcon';
import { styleSheet } from './styles';

interface IProps {
	enabled?: boolean;
	id: string;
	leadsProcessed?: number;
	logo?: React.ReactNode;
	onEnableClick?(id: string, enable: boolean, type: EmailScannerType): void;
	onManageClick?(): void;
	onTestClick?(): void;
	styles?: StyleDeclaration[];
	tags?: string[];
	type?: EmailScannerType;
}

export const LeadParserCard: React.FC<IProps> = ({
	enabled = false,
	leadsProcessed = 0,
	logo,
	id,
	onEnableClick,
	onManageClick,
	onTestClick,
	styles = [],
	tags = [],
	type,
}) => {
	const dropdownRef = useRef<HTMLDivElement>(null);

	const onEnableParser = () => {
		onEnableClick?.(id, !enabled, type);
	};

	const onManageCtaClick = () => {
		onManageClick?.();
	};

	const onTestCtaClick = () => {
		onTestClick?.();
	};

	return (
		<div className={css(styleSheet.container, ...styles)}>
			<div>
				<div className={css(styleSheet.iconContainer)}>{logo}</div>
				<div className={css(styleSheet.numLeadsParsedContainer)}>
					{`${enabled ? `${leadsProcessed} Lead${leadsProcessed === 1 ? '' : 's'} processed` : ''}`}
				</div>
				{tags.length > 0 && (
					<div className={css(styleSheet.tagsContainer)}>
						{tags.map((tag, i) => {
							return (
								<div className={css(styleSheet.tag)} key={i}>
									{tag}
								</div>
							);
						})}
					</div>
				)}
			</div>
			<div className={css(styleSheet.controlsContainer)}>
				{enabled ? (
					<div className={css(styleSheet.enabledIndicator)}>
						<SuccessCheckIcon />
						<span>Enabled</span>
					</div>
				) : (
					<button
						className={css(baseStyleSheet.ctaButtonReverseSmall, baseStyleSheet.flexCenter)}
						onClick={onEnableParser}
					>
						Enable
					</button>
				)}
				{enabled && !onManageClick && (
					<button
						className={css(baseStyleSheet.ctaButtonReverseSmall, baseStyleSheet.flexCenter)}
						onClick={onEnableParser}
					>
						Disable
					</button>
				)}
				{onManageClick && (
					<div className={css(styleSheet.dropdownContainer)} ref={dropdownRef}>
						{onTestClick ? (
							<>
								<CompoundButton
									buttonTitle='Manage'
									kind={CompoundButtonType.CtaPrimary}
									onClick={onManageCtaClick}
									openDirection='up'
								>
									<Button kind='primary' size='small' onClick={onTestCtaClick} styles={[styleSheet.dropdownButton]}>
										Test
									</Button>
								</CompoundButton>
							</>
						) : (
							<button
								className={css(baseStyleSheet.ctaButtonReverseSmall, baseStyleSheet.flexCenter)}
								onClick={onManageCtaClick}
							>
								Manage
							</button>
						)}
					</div>
				)}
			</div>
		</div>
	);
};
